<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link to="/setup/usage-rating/rum" class="vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("setup.label.EditRUM") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.RumName')"
              >
                <vs-input
                  v-model="rumName"
                  :label="$t('setup.label.RumName')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("setup.label.ChargeCode")
                }}<span class="required"> *</span></small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ChargeCode')"
                >
                  <v-select
                    label="chargeCode"
                    v-model="chargeCodeId"
                    :options="networkEleData.ChargeCodeDatas"
                    :reduce="(obj) => obj.id"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">
                      {{ option.chargeCode }}--{{ option.chargeDescription }}
                    </template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("setup.label.TemplateName")
                }}<span class="required"> *</span></small>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.TemplateName')"
                >
                  <v-select
                    label="templateName"
                    v-model="templateId"
                    :options="networkEleData.templateDatas"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    @input="getRumData(templateId)"
                    class="min-w-200 w-full mb-2"
                    :reduce="(obj) => obj.templateId"
                  >
                    <template v-slot:option="option">{{
                      option.templateName
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("setup.label.FieldName")
                }}</small>
                <v-select
                  label="fieldName"
                  v-model="fieldId"
                  :disabled="!templateId"
                  :options="networkEleData.FieldNamesDatas"
                  @input="calculateRumExpression(fieldId.fieldName)"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{
                    option.fieldName
                  }}</template>
                </v-select>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("setup.label.Operators")
                }}</small>
                <v-select
                  label="status"
                  v-model="selectedstatus"
                  :options="status"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  @input="calculateRumExpression(selectedstatus.status)"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{
                    option.status
                  }}</template>
                </v-select>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.RumExpression')"
              >
                <vs-input
                  v-model="rumExpression"
                  :label="$t('setup.label.RumExpression')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button class="mr-3 mb-2 footerButton-next" @click="editRum">{{
            $t("setup.label.Submit")
          }}</vs-button>
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";

export default {
  data() {
    return {
      networkEleData: {},
      rumName: "",
      rumExpression: "",
      chargeCodeId: "",
      templateId: "",
      fieldId: "",
      selectedstatus: "",
      status: [
        { status: "+", value: "+" },
        { status: "-", value: "-" },
        { status: "*", value: "*" },
        { status: "/", value: "/" },
        { status: "(", value: "(" },
        { status: ")", value: ")" },
        { status: "%", value: "%" },
      ],
      systemById: {},
      warningPopup: false,
      warningText: "",
      errorMessage: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    "v-select": vSelect,
  },

  computed: {
    ...mapState({
      rumTemplate: (state) => state.usageRating.rumTemplate,
      rumId: (state) => state.usageRating.rumId,
      rumWithTemplate: (state) => state.usageRating.rumWithTemplate,
    }),
  },
  methods: {
    calculateRumExpression(value) {
      if (!value) return;
      this.rumExpression = this.rumExpression + value;
      this.fieldId.fieldName + this.selectedstatus.status;
      this.fieldId = "";
      this.selectedstatus = "";
    },
    async getRUMTemplateData() {
      try {
        await this.$store.dispatch("usageRating/fetchRUMTemplateAction");
        this.networkEleData = this.rumTemplate;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getRumData(id) {
      try {
        this.rumExpression = "";
        await this.$store.dispatch("usageRating/fetchRUMByIdAction", id);
        this.rumData = this.rumId;
        this.fieldId = this.rumData.fieldId;
        this.networkEleData.FieldNamesDatas = this.rumId.fieldsData;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editRUMDataById() {
      try {
        await this.$store.dispatch(
          "usageRating/getRumWithTemplate",
          this.$route.params.id
        );
        this.systemById = this.rumWithTemplate;
        this.rumName = this.systemById.rumName;
        this.rumExpression = this.systemById.rumExpression;
        this.chargeCodeId = this.systemById.chargeCodeId;
        this.templateId = this.systemById.templateId;
        this.fieldId = this.systemById.fieldId;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editRum() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let payload = {
        rumName: this.rumName,
        rumExpression: this.rumExpression,
        chargeCodeId: this.chargeCodeId,
        templateId: this.templateId,
        fieldId: this.fieldId,
      };
      await this.$store.dispatch("usageRating/updateRumAction", {
        id: this.$route.params.id,
        data: payload,
      });
      this.$swal({
        title: "Success",
        icon: "success",
        text: "RUM Edited Successfully!",
        type: "success",
      });
      this.$router.push("/setup/usage-rating/rum");
    },
    cancel() {
      this.$router.push("/setup/usage-rating/rum");
    },
  },

  mounted() {
    this.getRUMTemplateData();
    this.editRUMDataById();
  },
};
</script>
